export default __webpack_public_path__ + "static/media/ic_fil_16.c1a98524.svg";